<template>
  <div>
    <!-- 顶部tab切换 -->
    <div class="function-nav">
      <div class="nav-tabs">
        <span v-for="tab in tabs" :key="tab.label" class="tab" :class="{active: activeTab === tab.label}" @click="switchTab(tab)">{{ tab.label }}</span>
      </div>
      <div class="refresh-btn">
        <button @click="onRefresh" style="background:#4caf50;color:#fff;border:none;padding:4px 16px;border-radius:4px;">刷新</button>
      </div>
    </div>

    <!-- 环境分析tab内容 -->
    <div v-if="activeTab === '环境分析'" class="tab-content">
      <!-- 筛选区 -->
      <div class="search-section-new">
        <form class="search-form-2x2">
          <div class="form-fields">
            <div class="form-item">
              <label>所属楼号：</label>
              <select class="form-input" v-model="analysisQuery.building">
                <option value="">全部</option>
                <option v-for="building in options.building" :key="building" :value="building">{{ building }}</option>
              </select>
            </div>
            <div class="form-item">
              <label>所属楼层：</label>
              <select class="form-input" v-model="analysisQuery.floor">
                <option value="">全部</option>
                <option v-for="floor in options.floor" :key="floor" :value="floor">{{ floor }}</option>
              </select>
            </div>
            <div class="form-item">
              <label>安装位置：</label>
              <select class="form-input" v-model="analysisQuery.facId">
                <option v-for="device in options.deviceList" :key="device.fac_id" :value="device.fac_id">{{ device.fac_name }} - {{ device.install_area }}</option>
              </select>
            </div>
            <div class="form-item">
              <label>设备类型：</label>
              <select class="form-input" v-model="analysisQuery.deviceType">
                <option value="温湿度表">温湿度表</option>
                <option value="压力表">压力表</option>
              </select>
            </div>
            <div class="form-item">
              <label>开始日期：</label>
              <input class="form-input" type="date" v-model="analysisQuery.startDate" />
            </div>
            <div class="form-item">
              <label>结束日期：</label>
              <input class="form-input" type="date" v-model="analysisQuery.endDate" />
            </div>
          </div>
          <div class="form-btns">
            <button type="button" class="search-btn-green" @click="startAnalysis">
               开始分析
            </button>
          </div>
        </form>
      </div>

      <!-- 分析标题 -->
      <div class="analysis-title" v-if="analysisData">
        <h2>园区环境分析 {{ formatDateRange() }}</h2>
      </div>

      <!-- 图表区域 -->
      <div class="charts-container" v-if="analysisData">
        <!-- 温湿度表图表 -->
        <template v-if="analysisQuery.deviceType === '温湿度表' || !analysisQuery.deviceType">
          <!-- 温度趋势图 -->
          <div class="chart-section">
            <div class="chart-header">
              <h3>周期内温度趋势</h3>
              <div class="chart-legend">
                <div class="legend-item">
                  <span class="legend-color blue"></span>
                  <span>今年温度</span>
                </div>
                <div class="legend-item">
                  <span class="legend-color pink"></span>
                  <span>去年温度</span>
                </div>
                <button class="download-btn" @click="downloadChart('temperature')">
                  📥
                </button>
              </div>
            </div>
            <div class="chart-container">
              <canvas ref="temperatureChart" width="800" height="400"></canvas>
            </div>
          </div>

          <!-- 湿度趋势图 -->
          <div class="chart-section">
            <div class="chart-header">
              <h3>周期内湿度趋势</h3>
              <div class="chart-legend">
                <div class="legend-item">
                  <span class="legend-color blue"></span>
                  <span>今年湿度</span>
                </div>
                <div class="legend-item">
                  <span class="legend-color green"></span>
                  <span>去年湿度</span>
                </div>
                <button class="download-btn" @click="downloadChart('humidity')">
                  📥
                </button>
              </div>
            </div>
            <div class="chart-container">
              <canvas ref="humidityChart" width="800" height="400"></canvas>
            </div>
          </div>
        </template>

        <!-- 压力表图表 -->
        <template v-if="analysisQuery.deviceType === '压力表'">
          <!-- 压力趋势图 -->
          <div class="chart-section">
            <div class="chart-header">
              <h3>周期内压力趋势</h3>
              <div class="chart-legend">
                <div class="legend-item">
                  <span class="legend-color blue"></span>
                  <span>今年压力</span>
                </div>
                <div class="legend-item">
                  <span class="legend-color orange"></span>
                  <span>去年压力</span>
                </div>
                <button class="download-btn" @click="downloadChart('pressure')">
                  📥
                </button>
              </div>
            </div>
            <div class="chart-container">
              <canvas ref="pressureChart" width="800" height="400"></canvas>
            </div>
          </div>
        </template>
      </div>

      <!-- 无数据提示 -->
      <div v-if="!analysisData && !analysisLoading" class="no-data">
        <p>请选择筛选条件并点击"开始分析"按钮</p>
      </div>

      <!-- 加载状态 -->
      <div v-if="analysisLoading" class="loading-state">
        <p>数据分析中...</p>
      </div>
    </div>

    <!-- 环境统计tab内容 -->
    <div v-if="activeTab === '环境统计'" class="tab-content">
      <!-- 子tab切换 -->
      <div class="subnav-bar">
        <button 
          v-for="subTab in subTabs" 
          :key="subTab.label" 
          class="subnav-tab" 
          :class="{active: activeSubTab === subTab.label}"
          @click="switchSubTab(subTab)"
        >
          {{ subTab.label }}
        </button>
      </div>

      <!-- 筛选区 -->
      <div class="search-section-new">
        <form class="search-form-2x2">
          <div class="form-fields">
            <div class="form-item">
              <label>所属楼号：</label>
              <select class="form-input" v-model="query.building">
                <option value="">全部</option>
                <option v-for="building in options.building" :key="building" :value="building">{{ building }}</option>
              </select>
            </div>
            <div class="form-item">
              <label>所属楼层：</label>
              <select class="form-input" v-model="query.floor">
                <option value="">全部</option>
                <option v-for="floor in options.floor" :key="floor" :value="floor">{{ floor }}</option>
              </select>
            </div>
            <div class="form-item">
              <label>安装位置：</label>
              <select class="form-input" v-model="query.facId">
                <option v-for="device in options.deviceList" :key="device.fac_id" :value="device.fac_id">{{ device.fac_name }} - {{ device.install_area }}</option>
              </select>
            </div>
            <div class="form-item">
              <label>设备类型：</label>
              <select class="form-input" v-model="query.deviceType">
                <option value="温湿度表">温湿度表</option>
                <option value="压力表">压力表</option>
              </select>
            </div>
            <div class="form-item">
              <label>开始日期：</label>
              <input class="form-input" :type="activeSubTab === '月报统计' ? 'month' : 'date'" v-model="query.startDate" />
            </div>
            <div class="form-item">
              <label>结束日期：</label>
              <input class="form-input" :type="activeSubTab === '月报统计' ? 'month' : 'date'" v-model="query.endDate" />
            </div>
          </div>
          <div class="form-btns">
            <button type="button" class="search-btn-green" @click="onRefresh">搜索</button>
            <button type="button" class="search-btn-green" @click="printTableData">打印</button>
          </div>
        </form>
      </div>

      <!-- 数据表格 -->
      <div class="data-section">
        <div class="table-container">
          <table class="data-table">
            <thead>
              <tr>
                <th>编号</th>
                <th>表名</th>
                <th>安装位置</th>
                <th v-for="col in getTableColumns()" :key="col">{{ getColumnLabel(col) }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading">
                <td :colspan="getTableColumns().length + 4" style="text-align:center;color:#bbb;">数据加载中...</td>
              </tr>
              <tr v-else-if="tableData.length === 0">
                <td :colspan="getTableColumns().length + 4" style="text-align:center;color:#bbb;">暂无数据</td>
              </tr>
              <template v-else>
                <tr v-for="(item, idx) in tableData" :key="idx">
                  <td>{{ item.id }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.location }}</td>
                  <td v-for="col in getTableColumns()" :key="col">{{ item.dailyData[col] || '-' }}</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- 维修分析tab内容 -->
    <div v-if="activeTab === '维修分析'" class="tab-content">
      <!-- 筛选区 -->
      <div class="search-section-new">
        <form class="search-form-2x2">
          <div class="form-fields">
            <div class="form-item">
              <label>开始日期：</label>
              <input class="form-input" type="month" v-model="maintenanceQuery.startDate" />
            </div>
            <div class="form-item">
              <label>结束日期：</label>
              <input class="form-input" type="month" v-model="maintenanceQuery.endDate" />
            </div>
          </div>
          <div class="form-btns">
            <button type="button" class="search-btn-green" @click="startMaintenanceAnalysis">
               开始分析
            </button>
          </div>
        </form>
      </div>

      <!-- 分析标题 -->
      <div class="analysis-title" v-if="maintenanceData">
        <h2>维修分析 {{ formatMaintenanceDateRange() }}</h2>
      </div>

      <!-- 图表区域 -->
      <div class="charts-container" v-if="maintenanceData">
        <!-- 维修数量统计图 -->
        <div class="chart-section">
          <div class="chart-header">
            <h3>维修数量统计</h3>
            <div class="chart-legend">
              <div class="legend-item">
                <span class="legend-color blue"></span>
                <span>温湿度表</span>
              </div>
              <div class="legend-item">
                <span class="legend-color green"></span>
                <span>压力表</span>
              </div>
              <button class="download-btn" @click="downloadChart('maintenance')">
                📥
              </button>
            </div>
          </div>
          <div class="chart-container">
            <canvas ref="maintenanceChart" width="800" height="400"></canvas>
          </div>
        </div>

        <!-- 设备维修比例图 -->
        <div class="chart-section">
          <div class="chart-header">
            <h3>设备维修比例</h3>
            <div class="chart-legend">
              <div class="legend-item">
                <span class="legend-color blue"></span>
                <span>温湿度表</span>
              </div>
              <div class="legend-item">
                <span class="legend-color green"></span>
                <span>压力表</span>
              </div>
              <button class="download-btn" @click="downloadChart('pie')">
                📥
              </button>
            </div>
          </div>
          <div class="chart-container">
            <canvas ref="pieChart" width="400" height="400"></canvas>
          </div>
        </div>
      </div>

      <!-- 统计摘要 -->
      <div class="summary-section" v-if="maintenanceData">
        <div class="summary-cards">
          <div class="summary-card">
            <div class="summary-title">温湿度表维修总数</div>
            <div class="summary-value">{{ maintenanceData.total_temperature_num }}</div>
            <div class="summary-unit">次</div>
          </div>
          <div class="summary-card">
            <div class="summary-title">压力表维修总数</div>
            <div class="summary-value">{{ maintenanceData.total_pressure_num }}</div>
            <div class="summary-unit">次</div>
          </div>
          <div class="summary-card">
            <div class="summary-title">总维修次数</div>
            <div class="summary-value">{{ this.maintenanceDataTotalNum }}</div>
            <div class="summary-unit">次</div>
          </div>
        </div>
      </div>

      <!-- 无数据提示 -->
      <div v-if="!maintenanceData && !maintenanceLoading" class="no-data">
        <p>请选择月份范围并点击"开始分析"按钮</p>
      </div>

      <!-- 加载状态 -->
      <div v-if="maintenanceLoading" class="loading-state">
        <p>维修数据分析中...</p>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js/auto';
import { HTTP_CONFIG } from '@/config/config.js'

export default {
  name: 'EnvAnalysis',
  data() {
    return {
      tabs: [
        { label: '环境分析' },
        { label: '环境统计' },
        { label: '维修分析' }
      ],
      activeTab: '环境分析',
      subTabs: [
        { label: '日报统计' },
        { label: '月报统计' }
      ],
      activeSubTab: '日报统计',
      query: {
        deviceType: '温湿度表',
        park: '',
        building: '',
        floor: '',
        installArea: '',
        facId: '',
        company: '',
        startDate: '',
        endDate: ''
      },
      analysisQuery: {
        deviceType: '温湿度表',
        park: '',
        building: '',
        floor: '',
        installArea: '',
        facId: '',
        company: '',
        startDate: '',
        endDate: ''
      },
      maintenanceQuery: {
        startDate: '',
        endDate: ''
      },
      options: {
        park: [],
        building: [],
        floor: [],
        installArea: [],
        company: [],
        deviceList: []
      },
      tableData: [],
      loading: false,
      hasMoreDays: true,
      analysisData: null,
      analysisLoading: false,
      maintenanceData: null,
      maintenanceLoading: false,
      temperatureChart: null,
      humidityChart: null,
      pressureChart: null,
      maintenanceChart: null,
      pieChart: null,
      lastQuery: null,
      lastAnalysisQuery: null,
      maintenanceDataTotalNum: 0
    }
  },
  watch: {
    // 监听环境统计tab的查询条件变化
    'query.park'() {
      // 厂区改变时，自动选择第一个楼号
      this.updateOptions().then(() => {
        if (this.options.building.length > 0 && !this.query.building) {
          this.query.building = this.options.building[0];
        }
      });
    },
    'query.building'() {
      // 楼号改变时，自动选择第一个楼层
      this.updateOptions().then(() => {
        if (this.options.floor.length > 0 && !this.query.floor) {
          this.query.floor = this.options.floor[0];
        }
      });
    },
    'query.floor'() {
      // 楼层改变时，自动选择第一个设备
      this.updateOptions().then(() => {
        if (this.options.deviceList.length > 0) {
          // 检查当前选择的设备是否还在列表中
          const currentDeviceExists = this.options.deviceList.some(device => device.fac_id === this.query.facId);
          if (!currentDeviceExists) {
            this.query.facId = this.options.deviceList[0].fac_id;
          }
        } else {
          this.query.facId = '';
        }
      });
    },
    'query.deviceType'() {
      // 设备类型改变时，自动选择第一个厂区
      this.updateOptions().then(() => {
        if (this.options.park.length > 0 && !this.query.park) {
          this.query.park = this.options.park[0];
        }
      });
    },
    // 监听环境分析tab的查询条件变化
    'analysisQuery.park'() {
      // 厂区改变时，自动选择第一个楼号
      this.updateAnalysisOptions().then(() => {

      });
    },
    'analysisQuery.building'() {
      // 楼号改变时，自动选择第一个楼层
      this.updateAnalysisOptions().then(() => {

      });
    },
    'analysisQuery.floor'() {
      // 楼层改变时，自动选择第一个设备
      this.updateAnalysisOptions().then(() => {

      });
    },
    'analysisQuery.deviceType'() {
      // 设备类型改变时，自动选择第一个厂区
      this.updateAnalysisOptions().then(() => {

      });
    },
    'activeTab'() {
      console.log(this.activeTab)
      if(this.activeTab == '维修分析') {
        if(this.analysisData) {
          this.analysisData = null;
        }
        if(this.maintenanceData) {
          this.maintenanceData = null;
        }
        if (this.pressureChart) {
          this.pressureChart.destroy();
        }
        if (this.temperatureChart) {
          this.temperatureChart.destroy();
        }
        if (this.humidityChart) {
          this.humidityChart.destroy();
        }
      }
      else if(this.activeTab == '环境分析') {
        if(this.analysisData) {
          this.analysisData = null;
        }
        if(this.maintenanceData) {
          this.maintenanceData = null;
        }
        if (this.pieChart) {
          this.pieChart.destroy();
        }
        if (this.maintenanceChart) {
          this.maintenanceChart.destroy();
        }
      }
    }
  },
  mounted() {
    this.initDefaultDates();
    this.initAnalysisDates();
    this.initMaintenanceDates();
    this.loadOptions();
  },
  methods: {
    // 初始化默认日期
    initDefaultDates() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      
      // 根据当前子tab设置日期格式
      if (this.activeSubTab === '月报统计') {
        this.query.startDate = `${year}-${month}`;
        this.query.endDate = `${year}-${month}`;
        } else {
        this.query.startDate = `${year}-${month}-${day}`;
        this.query.endDate = `${year}-${month}-${day}`;
      }
    },

    // 初始化分析日期（默认显示一个月的数据）
    initAnalysisDates() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      
      // 开始日期设为一个月前
      const oneMonthAgo = new Date(today);
      oneMonthAgo.setMonth(today.getMonth() - 1);
      const startYear = oneMonthAgo.getFullYear();
      const startMonth = String(oneMonthAgo.getMonth() + 1).padStart(2, '0');
      
      this.analysisQuery.startDate = `${startYear}-${startMonth}-${day}`;
      this.analysisQuery.endDate = `${year}-${month}-${day}`;
    },

    // 初始化维修分析日期（默认显示最近3个月的数据）
    initMaintenanceDates() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      
      // 开始日期设为3个月前
      const threeMonthsAgo = new Date(today);
      threeMonthsAgo.setMonth(today.getMonth() - 3);
      const startYear = threeMonthsAgo.getFullYear();
      const startMonth = String(threeMonthsAgo.getMonth() + 1).padStart(2, '0');
      
      this.maintenanceQuery.startDate = `${startYear}-${startMonth}`;
      this.maintenanceQuery.endDate = `${year}-${month}`;
    },

    // 切换主tab
    switchTab(tab) {
      this.activeTab = tab.label;
      if (this.activeTab === '环境统计') {
        this.loadOptions();
        this.loadTableData();
      } else if (this.activeTab === '环境分析') {
        this.loadOptions();
      } else if (this.activeTab === '维修分析') {
        // 维修分析不需要加载选项数据
      }
    },

    // 切换子tab
    switchSubTab(subTab) {
      this.activeSubTab = subTab.label;
      // 重新初始化日期格式
      this.initDefaultDates();
      this.loadTableData();
    },

    // 加载选项数据
    async loadOptions() {
      try {
        await Promise.all([
          this.loadParkOptions(),
          this.loadBuildingOptions(),
          this.loadFloorOptions(),
          this.loadInstallAreaOptions(),
          this.loadCompanyOptions(),
          this.loadDeviceOptions()
        ]);
      } catch (error) {
        console.error('加载选项数据失败:', error);
      }
    },

    // 加载厂区选项
    async loadParkOptions(queryParams = null) {
      try {
        const params = {};
        
        // 如果传入了查询参数，使用传入的参数
        if (queryParams) {
          if (queryParams.deviceType === '温湿度表') {
            params.fac_type = '0';
          } else if (queryParams.deviceType === '压力表') {
            params.fac_type = '1';
          }
          if (queryParams.building) params.building_number = queryParams.building;
          if (queryParams.floor) params.floor = queryParams.floor;
        }
        
        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/environment/query_fac_area_list/?${new URLSearchParams(params)}`);
        const data = await response.json();
        if (data && data.factory_area) {
          this.options.park = Array.from(data.factory_area).filter(Boolean);
        }
      } catch (error) {
        console.error('加载厂区选项失败:', error);
      }
    },

    // 加载楼号选项
    async loadBuildingOptions(queryParams = null) {
      try {
        const params = {};
        
        // 如果传入了查询参数，使用传入的参数
        if (queryParams) {
          if (queryParams.deviceType === '温湿度表') {
            params.fac_type = '0';
          } else if (queryParams.deviceType === '压力表') {
            params.fac_type = '1';
          }
          if (queryParams.park) params.factory_area = queryParams.park;
          if (queryParams.floor) params.floor = queryParams.floor;
        }
        
        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/environment/query_building_number_list/?${new URLSearchParams(params)}`);
        const data = await response.json();
        if (data && data.building_number) {
          this.options.building = Array.from(data.building_number).filter(Boolean);
        }
      } catch (error) {
        console.error('加载楼号选项失败:', error);
      }
    },

    // 加载楼层选项
    async loadFloorOptions(queryParams = null) {
      try {
        const params = {};
        
        // 如果传入了查询参数，使用传入的参数
        if (queryParams) {
          if (queryParams.deviceType === '温湿度表') {
            params.fac_type = '0';
          } else if (queryParams.deviceType === '压力表') {
            params.fac_type = '1';
          }
          if (queryParams.park) params.factory_area = queryParams.park;
          if (queryParams.building) params.building_number = queryParams.building;
        }
        
        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/environment/query_floor_list/?${new URLSearchParams(params)}`);
        const data = await response.json();
        if (data && data.floor) {
          this.options.floor = Array.from(data.floor).filter(Boolean);
        }
      } catch (error) {
        console.error('加载楼层选项失败:', error);
      }
    },

    // 加载安装位置选项
    async loadInstallAreaOptions(queryParams = null) {
      try {
        const params = new URLSearchParams();
        
        // 如果传入了查询参数，使用传入的参数
        if (queryParams) {
          if (queryParams.deviceType === '温湿度表') {
            params.append('fac_type', '0');
          } else if (queryParams.deviceType === '压力表') {
            params.append('fac_type', '1');
          }
          if (queryParams.park) {
            params.append('factory_area', queryParams.park);
          }
          if (queryParams.building) {
            params.append('building_number', queryParams.building);
          }
          if (queryParams.floor) {
            params.append('floor', queryParams.floor);
          }
          
          const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/environment/query_install_area_list/?${params}`);
          const data = await response.json();
          if (data && Array.isArray(data)) {
            this.options.installArea = data.filter(Boolean);
          }
        } else {
          // 如果没有查询参数，使用默认数据
          this.options.installArea = ['5楼西 (下电)', '5楼东 (上电)', '6楼西', '6楼东'];
        }
      } catch (error) {
        console.error('加载安装位置选项失败:', error);
      }
    },

    // 加载公司选项
    async loadCompanyOptions() {
      try {
        this.options.company = ['天津光电通信技术有限公司'];
      } catch (error) {
        console.error('加载公司选项失败:', error);
      }
    },

    // 加载设备选项
    async loadDeviceOptions() {
      try {
        const deviceType = this.activeTab === '环境分析' ? this.analysisQuery.deviceType : this.query.deviceType;
        const queryParams = this.activeTab === '环境分析' ? this.analysisQuery : this.query;
        
        if (!deviceType) {
          this.options.deviceList = [];
          return;
        }

        let apiUrl;
        if (deviceType === '温湿度表') {
          apiUrl = `${HTTP_CONFIG.SERVER_ADDR}/environment/query_TempHum_point_message/`;
        } else if (deviceType === '压力表') {
          apiUrl = `${HTTP_CONFIG.SERVER_ADDR}/environment/query_pressure_point_message/`;
        } else {
          this.options.deviceList = [];
          return;
        }

        const params = new URLSearchParams();
        params.append('page', 1);
        params.append('per_page', 1000); // 获取所有设备

        // 根据位置信息过滤设备
        if (queryParams.park) {
          params.append('factory_area', queryParams.park);
        }
        if (queryParams.building) {
          params.append('building_number', queryParams.building);
        }
        if (queryParams.floor) {
          params.append('floor', queryParams.floor);
        }

        const response = await fetch(`${apiUrl}?${params}`);
        const data = await response.json();
        
        if (data && data.data) {
          this.options.deviceList = data.data.map(item => ({
            fac_id: item.fac_id,
            fac_name: item.fac_name || '未命名',
            install_area: item.install_area || ''
          }));
        } else {
          this.options.deviceList = [];
        }
      } catch (error) {
        console.error('加载设备选项失败:', error);
        this.options.deviceList = [];
      }
    },

    // 智能更新选项（环境统计tab）
    async updateOptions() {
      try {
        const promises = [];
        
        if (this.query.deviceType !== this.lastQuery?.deviceType) {
          promises.push(
            this.loadParkOptions(this.query),
            this.loadBuildingOptions(this.query),
            this.loadFloorOptions(this.query),
            this.loadInstallAreaOptions(this.query),
            this.loadDeviceOptions()
          );
        }
        else if (this.query.park !== this.lastQuery?.park) {
          promises.push(
            this.loadBuildingOptions(this.query),
            this.loadFloorOptions(this.query),
            this.loadInstallAreaOptions(this.query),
            this.loadDeviceOptions()
          );
        }
        else if (this.query.building !== this.lastQuery?.building) {
          promises.push(
            this.loadFloorOptions(this.query),
            this.loadInstallAreaOptions(this.query),
            this.loadDeviceOptions()
          );
        }
        else if (this.query.floor !== this.lastQuery?.floor) {
          promises.push(
            this.loadInstallAreaOptions(this.query),
            this.loadDeviceOptions()
          );
        }
        
        if (promises.length > 0) {
          await Promise.all(promises);
        }
        
        this.lastQuery = { 
          deviceType: this.query.deviceType,
          park: this.query.park,
          building: this.query.building,
          floor: this.query.floor
        };
      } catch (error) {
        console.error('更新选项失败:', error);
      }
    },

    // 智能更新选项（环境分析tab）
    async updateAnalysisOptions() {
      try {
        const promises = [];
        
        if (this.analysisQuery.deviceType !== this.lastAnalysisQuery?.deviceType) {
          promises.push(
            this.loadParkOptions(this.analysisQuery),
            this.loadBuildingOptions(this.analysisQuery),
            this.loadFloorOptions(this.analysisQuery),
            this.loadInstallAreaOptions(this.analysisQuery),
            this.loadDeviceOptions()
          );
        }
        else if (this.analysisQuery.park !== this.lastAnalysisQuery?.park) {
          promises.push(
            this.loadBuildingOptions(this.analysisQuery),
            this.loadFloorOptions(this.analysisQuery),
            this.loadInstallAreaOptions(this.analysisQuery),
            this.loadDeviceOptions()
          );
        }
        else if (this.analysisQuery.building !== this.lastAnalysisQuery?.building) {
          promises.push(
            this.loadFloorOptions(this.analysisQuery),
            this.loadInstallAreaOptions(this.analysisQuery),
            this.loadDeviceOptions()
          );
        }
        else if (this.analysisQuery.floor !== this.lastAnalysisQuery?.floor) {
          promises.push(
            this.loadInstallAreaOptions(this.analysisQuery),
            this.loadDeviceOptions()
          );
        }
        
        if (promises.length > 0) {
          await Promise.all(promises);
        }
        
        this.lastAnalysisQuery = { 
          deviceType: this.analysisQuery.deviceType,
          park: this.analysisQuery.park,
          building: this.analysisQuery.building,
          floor: this.analysisQuery.floor
        };
      } catch (error) {
        console.error('更新分析选项失败:', error);
      }
    },

    // 加载表格数据
    async loadTableData() {
      this.loading = true;
      try {
        const apiUrl = this.activeSubTab === '日报统计' 
          ? `${HTTP_CONFIG.SERVER_ADDR}/environment/query_meter_daily_static/`
          : `${HTTP_CONFIG.SERVER_ADDR}/environment/query_meter_monthly_static/`;
        
        const params = this.buildQueryParams();
        const response = await fetch(`${apiUrl}?${params}`);
        const data = await response.json();
        
        if (data && data.data) {
          this.tableData = this.formatTableData(data.data);
        } else {
          this.tableData = [];
        }
      } catch (error) {
        console.error('加载表格数据失败:', error);
        this.tableData = [];
      } finally {
        this.loading = false;
      }
    },

    // 构建查询参数
    buildQueryParams() {
      const params = new URLSearchParams();
      
      if (this.query.park) {
        params.append('factory_area', this.query.park);
      }
      if (this.query.building) {
        params.append('building_number', this.query.building);
      }
      if (this.query.floor) {
        params.append('floor', this.query.floor);
      }
      if (this.query.installArea) {
        params.append('install_area', this.query.installArea);
      }
      if (this.query.facId) {
        params.append('fac_id', this.query.facId);
      }
      if (this.query.company) {
        params.append('company', this.query.company);
      }
      
      // 设置设备类型
      if (this.query.deviceType === '温湿度表') {
        params.append('fac_type', 0);
      } else if (this.query.deviceType === '压力表') {
        params.append('fac_type', 1);
      }
      // 如果没有选择设备类型，不传递fac_type参数，表示查询全部
      
      // 根据子tab设置日期格式
      if (this.activeSubTab === '月报统计') {
        // 月报统计使用 YYYY-MM 格式
        if (this.query.startDate) {
          const startDate = this.query.startDate;
          // 如果日期包含日，则只取年月部分
          const yearMonth = startDate.substring(0, 7);
          params.append('start_date', yearMonth);
        }
        if (this.query.endDate) {
          const endDate = this.query.endDate;
          const yearMonth = endDate.substring(0, 7);
          params.append('end_date', yearMonth);
        }
      } else {
        // 日报统计使用 YYYY-MM-DD 格式
        if (this.query.startDate) {
          params.append('start_date', this.query.startDate);
        }
        if (this.query.endDate) {
          params.append('end_date', this.query.endDate);
        }
      }
      
      return params.toString();
    },

    // 格式化数字，保留一位小数，处理带单位的情况
    formatNumberWithUnit(value) {
      if (value === null || value === undefined || value === '') {
        return value;
      }
      
      // 如果是字符串，尝试提取数字部分
      if (typeof value === 'string') {
        // 匹配数字（包括小数）和可能的单位
        const match = value.match(/^([+-]?\d*\.?\d+)(.*)$/);
        if (match) {
          const numberPart = parseFloat(match[1]);
          const unitPart = match[2] || '';
          
          if (!isNaN(numberPart)) {
            return (numberPart.toFixed(1) + unitPart).trim();
          }
        }
        return value;
      }
      
      // 如果是数字，直接格式化
      if (typeof value === 'number') {
        return value.toFixed(1);
      }
      
      return value;
    },
    formatPressure(value) {
      return (value / 1000).toFixed(2);
    },

    // 格式化温湿度复合数据，保留一位小数
    formatTemperatureHumidityData(value) {
      if (value === null || value === undefined || value === '') {
        return value;
      }
      
      if (typeof value === 'string') {
        // 处理温湿度复合格式：如 "27.0℃ / 72.32749999999999%RH"
        const tempHumidityMatch = value.match(/^([+-]?\d*\.?\d+)(℃)\s*\/\s*([+-]?\d*\.?\d+)(%RH)$/);
        if (tempHumidityMatch) {
          const tempValue = parseFloat(tempHumidityMatch[1]);
          const tempUnit = tempHumidityMatch[2];
          const humidityValue = parseFloat(tempHumidityMatch[3]);
          const humidityUnit = tempHumidityMatch[4];
          
          if (!isNaN(tempValue) && !isNaN(humidityValue)) {
            return `${tempValue.toFixed(1)}${tempUnit} / ${humidityValue.toFixed(1)}${humidityUnit}`;
          }
        }
        
        // 如果不是复合格式，尝试处理简单格式
        return this.formatNumberWithUnit(value);
      }
      
      // 如果是数字，直接格式化
      if (typeof value === 'number') {
        return value.toFixed(1);
      }
      
      return value;
    },

    // 格式化维修数据数字，不保留小数，处理带单位的情况
    formatMaintenanceNumber(value) {
      if (value === null || value === undefined || value === '') {
        return value;
      }
      
      // 如果是字符串，尝试提取数字部分
      if (typeof value === 'string') {
        // 匹配数字（包括小数）和可能的单位
        const match = value.match(/^([+-]?\d*\.?\d+)(.*)$/);
        if (match) {
          const numberPart = parseFloat(match[1]);
          const unitPart = match[2] || '';
          
          if (!isNaN(numberPart)) {
            return (Math.round(numberPart) + unitPart).trim();
          }
        }
        return value;
      }
      
      // 如果是数字，直接取整
      if (typeof value === 'number') {
        return Math.round(value).toString();
      }
      
      return value;
    },

    // 格式化表格数据
    formatTableData(rawData) {
      const formattedData = [];
      
      for (const [key, value] of Object.entries(rawData)) {
        const [id, name, location] = key.split(',');
        const dailyData = {};
        
        // 处理每日数据
        value.forEach(item => {
          if (this.activeSubTab === '日报统计') {
            const date = new Date(item.record_date);
            const day = date.getDate();
            dailyData[day] = this.formatTemperatureHumidityData(item.data);
          } else {
            // 月报统计
            const [, month] = item.record_date.split('-');
            dailyData[month] = this.formatTemperatureHumidityData(item.data);
          }
        });
        
        formattedData.push({
          id: id || '未知',
          name: name || '未命名',
          location: location || '未知位置',
          dailyData
        });
      }
      
      return formattedData;
    },

    // 获取表格列
    getTableColumns() {
      if (this.activeSubTab === '日报统计') {
        return this.getVisibleDays();
      } else {
        return this.getMonthlyColumns();
      }
    },

    // 获取列标签
    getColumnLabel(col) {
      if (this.activeSubTab === '日报统计') {
        return `${col}日`;
      } else {
        return `${col}月`;
      }
    },

    // 动态获取可见天数
    getVisibleDays() {
      if (!this.query.startDate || !this.query.endDate) {
        return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]; // 默认值
      }

      const startDate = new Date(this.query.startDate);
      const endDate = new Date(this.query.endDate);
      const days = [];

      const currentDate = new Date(startDate);
      while (currentDate <= endDate) {
        days.push(currentDate.getDate());
        currentDate.setDate(currentDate.getDate() + 1);
      }

      return days;
    },

    // 动态获取月份列
    getMonthlyColumns() {
      if (!this.query.startDate || !this.query.endDate) {
        return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]; // 默认值
      }

      const startDate = new Date(this.query.startDate);
      const endDate = new Date(this.query.endDate);
      const months = [];

      const currentDate = new Date(startDate);
      while (currentDate <= endDate) {
        months.push(currentDate.getMonth() + 1);
        currentDate.setMonth(currentDate.getMonth() + 1);
      }

      return months;
    },

    // 验证日期跨度
    validateDateRange() {
      if (!this.query.startDate || !this.query.endDate) {
        alert('请选择开始日期和结束日期');
        return false;
      }

      const startDate = new Date(this.query.startDate);
      const endDate = new Date(this.query.endDate);
      
      if (startDate > endDate) {
        alert('开始日期不能大于结束日期');
        return false;
      }

      // 计算日期差
      const timeDiff = endDate.getTime() - startDate.getTime();
      const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1; // +1 包含开始日期
      
      if (this.activeSubTab === '日报统计') {
        if (daysDiff >32) {
          alert('日报统计日期跨度不能超过一个月');
          return false;
        }
      } else if (this.activeSubTab === '月报统计') {
        // 计算月份差
        const monthsDiff = (endDate.getFullYear() - startDate.getFullYear()) * 12 + 
                          (endDate.getMonth() - startDate.getMonth()) + 1; // +1 包含开始月份
        if (monthsDiff > 12) {
          alert('月报统计日期跨度不能超过12个月');
          return false;
        }
      }
      
      return true;
    },

    // 搜索
    onSearch() {
      // 验证日期跨度
      if (!this.validateDateRange()) {
        return;
      }
      this.loadTableData();
      window.print();
    },

    // 开始环境分析
    async startAnalysis() {
      // 验证日期跨度
      if (!this.validateAnalysisDateRange()) {
        return;
      }
      
      this.analysisLoading = true;
      try {
        const params = this.buildAnalysisQueryParams();
        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/environment/query_environment_analysis/?${params}`);
        const data = await response.json();
        
        if (data && (data.this_year_data || data.last_year_data)) {
          this.analysisData = this.formatAnalysisData(data);
          this.$nextTick(() => {
            this.renderCharts();
          });
        } else {
          this.analysisData = null;
        }
      } catch (error) {
        console.error('环境分析失败:', error);
        this.analysisData = null;
      } finally {
        this.analysisLoading = false;
      }
    },

    // 验证环境分析日期跨度
    validateAnalysisDateRange() {
      if (!this.analysisQuery.startDate || !this.analysisQuery.endDate) {
        alert('请选择开始日期和结束日期');
        return false;
      }

      const startDate = new Date(this.analysisQuery.startDate);
      const endDate = new Date(this.analysisQuery.endDate);
      
      if (startDate > endDate) {
        alert('开始日期不能大于结束日期');
        return false;
      }

      // 计算日期差
      const timeDiff = endDate.getTime() - startDate.getTime();
      const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1; // +1 包含开始日期
      
      if (daysDiff > 32) {
        alert('环境分析日期跨度不能超过31天');
        return false;
      }
      
      return true;
    },

    // 格式化分析数据
    formatAnalysisData(data) {
      const formattedData = { ...data };
      console.log(formattedData)
      // 格式化今年数据
      if (formattedData.this_year_data && Array.isArray(formattedData.this_year_data)) {
        formattedData.this_year_data = formattedData.this_year_data.map(item => ({
          ...item,
          temperature: item.temperature ? item.temperature.map(val => this.formatNumberWithUnit(val)) : [],
          humidity: item.humidity ? item.humidity.map(val => this.formatNumberWithUnit(val)) : [],
          pressure: item.pressure ? item.pressure.map(val => this.formatPressure(val)) : []
        }));
      }
      
      // 格式化去年数据
      if (formattedData.last_year_data && Array.isArray(formattedData.last_year_data)) {
        formattedData.last_year_data = formattedData.last_year_data.map(item => ({
          ...item,
          temperature: item.temperature ? item.temperature.map(val => this.formatNumberWithUnit(val)) : [],
          humidity: item.humidity ? item.humidity.map(val => this.formatNumberWithUnit(val)) : [],
          pressure: item.pressure ? item.pressure.map(val => this.formatPressure(val)) : []
        }));
      }
      
      return formattedData;
    },

    // 构建分析查询参数
    buildAnalysisQueryParams() {
      const params = new URLSearchParams();
      
      if (this.analysisQuery.park) {
        params.append('factory_area', this.analysisQuery.park);
      }
      if (this.analysisQuery.building) {
        params.append('building_number', this.analysisQuery.building);
      }
      if (this.analysisQuery.floor) {
        params.append('floor', this.analysisQuery.floor);
      }
      if (this.analysisQuery.installArea) {
        params.append('install_area', this.analysisQuery.installArea);
      }
      if (this.analysisQuery.facId) {
        params.append('fac_id', this.analysisQuery.facId);
      }
      if (this.analysisQuery.company) {
        params.append('company', this.analysisQuery.company);
      }
      if (this.analysisQuery.startDate) {
        params.append('start_date', this.analysisQuery.startDate);
      }
      if (this.analysisQuery.endDate) {
        params.append('end_date', this.analysisQuery.endDate);
      }
      
      // 设置设备类型
      if (this.analysisQuery.deviceType === '温湿度表') {
        params.append('fac_type', 0);
      } else if (this.analysisQuery.deviceType === '压力表') {
        params.append('fac_type', 1);
      }
      // 如果没有选择设备类型，不传递fac_type参数，表示查询全部
      
      return params.toString();
    },

    // 格式化日期范围显示
    formatDateRange() {
      if (!this.analysisQuery.startDate || !this.analysisQuery.endDate) {
        return '';
      }
      const startDate = new Date(this.analysisQuery.startDate);
      const endDate = new Date(this.analysisQuery.endDate);
      
      const formatDate = (date) => {
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${month}-${day}`;
      };
      
      return `${formatDate(startDate)}--${formatDate(endDate)}`;
    },

    // 渲染图表
    renderCharts() {
      if (this.analysisQuery.deviceType === '压力表') {
        this.renderPressureChart();
      } else {
        // 温湿度表或未选择时显示温湿度图表
        this.renderTemperatureChart();
        this.renderHumidityChart();
      }
    },

    // 渲染温度趋势图
    renderTemperatureChart() {
      const ctx = this.$refs.temperatureChart;
      if (!ctx || !this.analysisData) return;

      if (this.pressureChart) {
        this.pressureChart.destroy();
      }
      if (this.temperatureChart) {
        this.temperatureChart.destroy();
      }

      // 修正数据获取方式 - 直接从数组获取，而不是从[0]索引
      const thisYearData = this.analysisData.this_year_data?.[0]?.temperature || [];
      const lastYearData = this.analysisData.last_year_data?.[0]?.temperature || [];
      
      // 使用接口返回的日期数据
      const thisYearDates = this.analysisData.this_year_data?.[0]?.date || [];
      const lastYearDates = this.analysisData.last_year_data?.[0]?.date || [];
      
      // 添加调试信息
      console.log('温度数据:', { thisYearData, lastYearData, thisYearDates, lastYearDates });
      
      // 检查数据是否为空
      if (thisYearData.length === 0 && lastYearData.length === 0) {
        console.warn('没有温度数据可显示');
        return;
      }
      
      // 格式化日期标签，显示为 MM-DD 格式
      const formatDateLabels = (dates) => {
        return dates.map(dateStr => {
          const date = new Date(dateStr);
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${month}-${day}`;
        });
      };
      
      // 使用今年数据的日期作为主要标签，如果今年没有数据则使用去年的日期
      const labels = thisYearDates.length > 0 ? formatDateLabels(thisYearDates) : formatDateLabels(lastYearDates);
      
      this.temperatureChart = new Chart(ctx, {
        type: 'line',
        data: {
          labels: labels,
          datasets: [
            {
              label: '今年温度',
              data: thisYearData,
              borderColor: '#2196F3',
              backgroundColor: 'rgba(33, 150, 243, 0.1)',
              tension: 0.4,
              pointRadius: 4,
              pointHoverRadius: 6
            },
            {
              label: '去年温度',
              data: lastYearData,
              borderColor: '#E91E63',
              backgroundColor: 'rgba(233, 30, 99, 0.1)',
              tension: 0.4,
              pointRadius: 4,
              pointHoverRadius: 6
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            y: {
              beginAtZero: false,
              title: {
                display: true,
                text: '°C'
              },
              min: -20,
              max: 60,
              ticks: {
                stepSize: 10
              }
            },
            x: {
              title: {
                display: true,
                text: '日期'
              }
            }
          },
          plugins: {
            tooltip: {
              mode: 'index',
              intersect: false,
              callbacks: {
                title: (context) => {
                  // 使用实际的日期数据
                  const dateIndex = context[0].dataIndex;
                  const actualDate = thisYearDates[dateIndex] || lastYearDates[dateIndex];
                  if (actualDate) {
                    const date = new Date(actualDate);
                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    const day = String(date.getDate()).padStart(2, '0');
                    return `${year}-${month}-${day}`;
                  }
                  return context[0].label;
                },
                label: (context) => {
                  return `${context.dataset.label}: ${context.parsed.y}°C`;
                }
              }
            },
            legend: {
              display: false
            }
          }
        }
      });
    },

    // 渲染湿度趋势图
    renderHumidityChart() {
      const ctx = this.$refs.humidityChart;
      if (!ctx || !this.analysisData) return;

      if (this.pressureChart) {
        this.pressureChart.destroy();
      }
      if (this.humidityChart) {
        this.humidityChart.destroy();
      }

      // 修正数据获取方式 - 直接从数组获取，而不是从[0]索引
      const thisYearData = this.analysisData.this_year_data?.[0]?.humidity || [];
      const lastYearData = this.analysisData.last_year_data?.[0]?.humidity || [];
      
      // 使用接口返回的日期数据
      const thisYearDates = this.analysisData.this_year_data?.[0]?.date || [];
      const lastYearDates = this.analysisData.last_year_data?.[0]?.date || [];
      
      // 添加调试信息
      console.log('湿度数据:', { thisYearData, lastYearData, thisYearDates, lastYearDates });
      
      // 检查数据是否为空
      if (thisYearData.length === 0 && lastYearData.length === 0) {
        console.warn('没有湿度数据可显示');
        return;
      }
      
      // 格式化日期标签，显示为 MM-DD 格式
      const formatDateLabels = (dates) => {
        return dates.map(dateStr => {
          const date = new Date(dateStr);
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${month}-${day}`;
        });
      };
      
      // 使用今年数据的日期作为主要标签，如果今年没有数据则使用去年的日期
      const labels = thisYearDates.length > 0 ? formatDateLabels(thisYearDates) : formatDateLabels(lastYearDates);
      
      this.humidityChart = new Chart(ctx, {
        type: 'line',
        data: {
          labels: labels,
          datasets: [
            {
              label: '今年湿度',
              data: thisYearData,
              borderColor: '#2196F3',
              backgroundColor: 'rgba(33, 150, 243, 0.1)',
              tension: 0.4,
              pointRadius: 4,
              pointHoverRadius: 6
            },
            {
              label: '去年湿度',
              data: lastYearData,
              borderColor: '#4CAF50',
              backgroundColor: 'rgba(76, 175, 80, 0.1)',
              tension: 0.4,
              pointRadius: 4,
              pointHoverRadius: 6
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            y: {
              beginAtZero: false,
              title: {
                display: true,
                text: '%'
              },
              min: 0,
              max: 100,
              ticks: {
                stepSize: 20
              }
            },
            x: {
              title: {
                display: true,
                text: '日期'
              }
            }
          },
          plugins: {
            tooltip: {
              mode: 'index',
              intersect: false,
              callbacks: {
                title: (context) => {
                  // 使用实际的日期数据
                  const dateIndex = context[0].dataIndex;
                  const actualDate = thisYearDates[dateIndex] || lastYearDates[dateIndex];
                  if (actualDate) {
                    const date = new Date(actualDate);
                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    const day = String(date.getDate()).padStart(2, '0');
                    return `${year}-${month}-${day}`;
                  }
                  return context[0].label;
                },
                label: (context) => {
                  return `${context.dataset.label}: ${context.parsed.y}%`;
                }
              }
            },
            legend: {
              display: false
            }
          }
        }
      });
    },

    // 渲染压力趋势图
    renderPressureChart() {
      const ctx = this.$refs.pressureChart;
      if (!ctx || !this.analysisData) return;

      if (this.pressureChart) {
        this.pressureChart.destroy();
      }
      if (this.temperatureChart) {
        this.temperatureChart.destroy();
      }
      if (this.humidityChart) {
        this.humidityChart.destroy();
      }

      // 从分析数据中获取压力数据
      const thisYearData = this.analysisData.this_year_data?.[0]?.pressure || [];
      const lastYearData = this.analysisData.last_year_data?.[0]?.pressure || [];
      
      // 使用接口返回的日期数据
      const thisYearDates = this.analysisData.this_year_data?.[0]?.date || [];
      const lastYearDates = this.analysisData.last_year_data?.[0]?.date || [];
      
      // 添加调试信息
      console.log('压力数据:', { thisYearData, lastYearData, thisYearDates, lastYearDates });
      
      // 检查数据是否为空
      if (thisYearData.length === 0 && lastYearData.length === 0) {
        console.warn('没有压力数据可显示');
        return;
      }
      
      // 格式化日期标签，显示为 MM-DD 格式
      const formatDateLabels = (dates) => {
        return dates.map(dateStr => {
          const date = new Date(dateStr);
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${month}-${day}`;
        });
      };
      
      // 使用今年数据的日期作为主要标签，如果今年没有数据则使用去年的日期
      const labels = thisYearDates.length > 0 ? formatDateLabels(thisYearDates) : formatDateLabels(lastYearDates);
      
      this.pressureChart = new Chart(ctx, {
        type: 'line',
        data: {
          labels: labels,
          datasets: [
            {
              label: '今年压力',
              data: thisYearData,
              borderColor: '#2196F3',
              backgroundColor: 'rgba(33, 150, 243, 0.1)',
              tension: 0.4,
              pointRadius: 4,
              pointHoverRadius: 6
            },
            {
              label: '去年压力',
              data: lastYearData,
              borderColor: '#FF9800',
              backgroundColor: 'rgba(255, 152, 0, 0.1)',
              tension: 0.4,
              pointRadius: 4,
              pointHoverRadius: 6
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            y: {
              beginAtZero: false,
              title: {
                display: true,
                text: 'MPa'
              },
              min: 0,
              max: 1,
              ticks: {
                stepSize: 20
              }
            },
            x: {
              title: {
                display: true,
                text: '日期'
              }
            }
          },
          plugins: {
            tooltip: {
              mode: 'index',
              intersect: false,
              callbacks: {
                title: (context) => {
                  // 使用实际的日期数据
                  const dateIndex = context[0].dataIndex;
                  const actualDate = thisYearDates[dateIndex] || lastYearDates[dateIndex];
                  if (actualDate) {
                    const date = new Date(actualDate);
                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    const day = String(date.getDate()).padStart(2, '0');
                    return `${year}-${month}-${day}`;
                  }
                  return context[0].label;
                },
                label: (context) => {
                  return `${context.dataset.label}: ${context.parsed.y}MPa`;
                }
              }
            },
            legend: {
              display: false
            }
          }
        }
      });
    },

    // 生成日期标签
    generateDateLabels() {
      if (!this.analysisQuery.startDate || !this.analysisQuery.endDate) {
        return [];
      }
      
      const startDate = new Date(this.analysisQuery.startDate);
      const endDate = new Date(this.analysisQuery.endDate);
      const labels = [];
      
      const currentDate = new Date(startDate);
      while (currentDate <= endDate) {
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        labels.push(`${month}-${day}`);
        currentDate.setDate(currentDate.getDate() + 1);
      }
      
      return labels;
    },

    // 下载图表
    downloadChart(type) {
      let canvas;
      let filename;
      
      if (type === 'temperature') {
        canvas = this.$refs.temperatureChart;
        filename = '温度趋势图.png';
      } else if (type === 'humidity') {
        canvas = this.$refs.humidityChart;
        filename = '湿度趋势图.png';
      } else if (type === 'pressure') {
        canvas = this.$refs.pressureChart;
        filename = '压力趋势图.png';
      } else if (type === 'maintenance') {
        canvas = this.$refs.maintenanceChart;
        filename = '维修数量统计图.png';
      } else if (type === 'pie') {
        canvas = this.$refs.pieChart;
        filename = '设备维修比例图.png';
      }
      
      if (canvas) {
        const link = document.createElement('a');
        link.download = filename;
        link.href = canvas.toDataURL();
        link.click();
      }
    },

    // 刷新
    onRefresh() {
      if (this.activeTab === '环境统计') {
        this.loadOptions();
        this.loadTableData();
      } else if (this.activeTab === '环境分析') {
        this.loadOptions();
        this.startAnalysis();
      } else if (this.activeTab === '维修分析') {
        // 维修分析刷新时重新加载数据
        if (this.maintenanceQuery.startDate && this.maintenanceQuery.endDate) {
          this.startMaintenanceAnalysis();
        }
      }
    },

    // 开始维修分析
    async startMaintenanceAnalysis() {
      this.maintenanceLoading = true;
      try {
        const params = this.buildMaintenanceQueryParams();
        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/environment/query_maintenance_analysis/?${params}`);
        const data = await response.json();
        
        if (data && (data.total_temperature_num !== undefined || data.total_pressure_num !== undefined)) {
          // 格式化维修数据中的数字
          this.maintenanceData = this.formatMaintenanceData(data);
          this.$nextTick(() => {
            this.renderMaintenanceCharts();
          });
        } else {
          this.maintenanceData = null;
        }
      } catch (error) {
        console.error('维修分析失败:', error);
        this.maintenanceData = null;
      } finally {
        this.maintenanceLoading = false;
      }
    },

    // 格式化维修数据
    formatMaintenanceData(data) {
      const formattedData = { ...data };
      
      // 格式化总数
      if (formattedData.total_temperature_num !== undefined) {
        formattedData.total_temperature_num = this.formatMaintenanceNumber(formattedData.total_temperature_num);
      }
      if (formattedData.total_pressure_num !== undefined) {
        formattedData.total_pressure_num = this.formatMaintenanceNumber(formattedData.total_pressure_num);
      }
      this.maintenanceDataTotalNum = parseInt(formattedData.total_temperature_num) + parseInt(formattedData.total_pressure_num);
      
      // 格式化月度数据
      if (formattedData.monthly_temperature_num && Array.isArray(formattedData.monthly_temperature_num)) {
        formattedData.monthly_temperature_num = formattedData.monthly_temperature_num.map(item => {
          const newItem = {};
          for (const [key, value] of Object.entries(item)) {
            newItem[key] = this.formatMaintenanceNumber(value);
          }
          return newItem;
        });
      }
      
      if (formattedData.monthly_pressure_num && Array.isArray(formattedData.monthly_pressure_num)) {
        formattedData.monthly_pressure_num = formattedData.monthly_pressure_num.map(item => {
          const newItem = {};
          for (const [key, value] of Object.entries(item)) {
            newItem[key] = this.formatMaintenanceNumber(value);
          }
          return newItem;
        });
      }
      
      return formattedData;
    },

    // 构建维修分析查询参数
    buildMaintenanceQueryParams() {
      const params = new URLSearchParams();
      
      if (this.maintenanceQuery.startDate) {
        params.append('start_date', this.maintenanceQuery.startDate);
      }
      if (this.maintenanceQuery.endDate) {
        params.append('end_date', this.maintenanceQuery.endDate);
      }
      
      return params.toString();
    },

    // 格式化维修日期范围显示
    formatMaintenanceDateRange() {
      if (!this.maintenanceQuery.startDate || !this.maintenanceQuery.endDate) {
        return '';
      }
      const startDate = new Date(this.maintenanceQuery.startDate);
      const endDate = new Date(this.maintenanceQuery.endDate);
      
      const formatDate = (date) => {
        const month = String(date.getMonth() + 1).padStart(2, '0');
        return `${month}`;
      };
      
      return `${formatDate(startDate)}--${formatDate(endDate)}`;
    },

    // 渲染维修分析图表
    renderMaintenanceCharts() {
      this.renderMaintenanceBarChart();
      this.renderMaintenancePieChart();
    },

    // 渲染维修数量统计图
    renderMaintenanceBarChart() {
      const ctx = this.$refs.maintenanceChart;
      if (!ctx || !this.maintenanceData) return;

      if (this.maintenanceChart) {
        this.maintenanceChart.destroy();
      }

      // 从后端数据中提取月度维修数据
      const monthlyTempData = this.maintenanceData.monthly_temperature_num || [];
      const monthlyPressureData = this.maintenanceData.monthly_pressure_num || [];
      
      // 生成月份标签
      const labels = this.generateMaintenanceMonthLabels();
      
      // 处理数据格式，提取维修数量
      const tempCounts = monthlyTempData.map(item => {
        const key = Object.keys(item)[0];
        return item[key];
      });
      
      const pressureCounts = monthlyPressureData.map(item => {
        const key = Object.keys(item)[0];
        return item[key];
      });
      
      this.maintenanceChart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: labels,
          datasets: [
            {
              label: '温湿度表',
              data: tempCounts,
              backgroundColor: 'rgba(33, 150, 243, 0.7)',
              borderColor: '#2196F3',
              borderWidth: 1
            },
            {
              label: '压力表',
              data: pressureCounts,
              backgroundColor: 'rgba(76, 175, 80, 0.7)',
              borderColor: '#4CAF50',
              borderWidth: 1
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            y: {
              beginAtZero: true,
              title: {
                display: true,
                text: '次'
              },
              ticks: {
                stepSize: 1
              }
            },
            x: {
              title: {
                display: true,
                text: '月份'
              }
            }
          },
          plugins: {
            tooltip: {
              mode: 'index',
              intersect: false,
              callbacks: {
                label: function(context) {
                  return `${context.dataset.label}: ${context.parsed.y}次`;
                }
              }
            },
            legend: {
              display: false
            }
          }
        }
      });
    },

    // 渲染维修比例饼图
    renderMaintenancePieChart() {
      const ctx = this.$refs.pieChart;
      if (!ctx || !this.maintenanceData) return;

      if (this.pieChart) {
        this.pieChart.destroy();
      }

      const tempTotal = this.maintenanceData.total_temperature_num || 0;
      const pressureTotal = this.maintenanceData.total_pressure_num || 0;
      
      if (tempTotal === 0 && pressureTotal === 0) {
        return; // 没有数据时不显示图表
      }

      this.pieChart = new Chart(ctx, {
        type: 'pie',
        data: {
          labels: ['温湿度表', '压力表'],
          datasets: [{
            data: [tempTotal, pressureTotal],
            backgroundColor: [
              'rgba(33, 150, 243, 0.8)',
              'rgba(76, 175, 80, 0.8)'
            ],
            borderColor: [
              '#2196F3',
              '#4CAF50'
            ],
            borderWidth: 2
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            tooltip: {
              callbacks: {
                label: function(context) {
                  const total = context.dataset.data.reduce((a, b) => parseInt(a) + parseInt(b), 0);
                  const percentage = ((context.parsed / total) * 100).toFixed(0);
                  return `${context.label}: ${context.parsed}次 (${percentage}%)`;
                }
              }
            },
            legend: {
              position: 'bottom',
              labels: {
                usePointStyle: true,
                padding: 20
              }
            }
          }
        }
      });
    },

    // 生成维修分析月份标签
    generateMaintenanceMonthLabels() {
      if (!this.maintenanceQuery.startDate || !this.maintenanceQuery.endDate) {
        return [];
      }
      
      const startDate = new Date(this.maintenanceQuery.startDate);
      const endDate = new Date(this.maintenanceQuery.endDate);
      const labels = [];
      
      const currentDate = new Date(startDate);
      while (currentDate <= endDate) {
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        labels.push(`${month}月`);
        currentDate.setMonth(currentDate.getMonth() + 1);
      }
      
      return labels;
    },

    // 打印表格数据
    async printTableData() {
      try {
        console.log('=== 开始打印环境统计数据 ===');
        
        // 构建查询参数，设置per_page为500获取所有数据
        const params = this.buildPrintQueryParams();
        
        console.log('打印查询参数:', params);
        
        // 调用API获取所有数据
        const apiUrl = this.activeSubTab === '日报统计' 
          ? `${HTTP_CONFIG.SERVER_ADDR}/environment/query_meter_daily_static/`
          : `${HTTP_CONFIG.SERVER_ADDR}/environment/query_meter_monthly_static/`;
        
        const response = await fetch(`${apiUrl}?${params}`);
        const data = await response.json();
        
        let allData = [];
        
        if (data && data.data) {
          allData = this.formatTableData(data.data);
        }
        
        console.log('获取到数据条数:', allData.length);
        
        if (allData.length === 0) {
          alert('没有数据可以打印');
          return;
        }
        
        // 创建打印内容
        this.createPrintContent(allData);
        
      } catch (error) {
        console.error('打印数据失败:', error);
        alert('打印失败: ' + error.message);
      }
    },

    // 构建打印查询参数
    buildPrintQueryParams() {
      const params = new URLSearchParams();
      
      if (this.query.park) {
        params.append('factory_area', this.query.park);
      }
      if (this.query.building) {
        params.append('building_number', this.query.building);
      }
      if (this.query.floor) {
        params.append('floor', this.query.floor);
      }
      if (this.query.installArea) {
        params.append('install_area', this.query.installArea);
      }
      if (this.query.facId) {
        params.append('fac_id', this.query.facId);
      }
      if (this.query.company) {
        params.append('company', this.query.company);
      }
      
      // 设置设备类型
      if (this.query.deviceType === '温湿度表') {
        params.append('fac_type', 0);
      } else if (this.query.deviceType === '压力表') {
        params.append('fac_type', 1);
      }
      
      // 根据子tab设置日期格式
      if (this.activeSubTab === '月报统计') {
        // 月报统计使用 YYYY-MM 格式
        if (this.query.startDate) {
          const startDate = this.query.startDate;
          const yearMonth = startDate.substring(0, 7);
          params.append('start_date', yearMonth);
        }
        if (this.query.endDate) {
          const endDate = this.query.endDate;
          const yearMonth = endDate.substring(0, 7);
          params.append('end_date', yearMonth);
        }
      } else {
        // 日报统计使用 YYYY-MM-DD 格式
        if (this.query.startDate) {
          params.append('start_date', this.query.startDate);
        }
        if (this.query.endDate) {
          params.append('end_date', this.query.endDate);
        }
      }
      
      params.append('page', 1);
      params.append('per_page', 500); // 获取所有数据
      
      return params.toString();
    },

    // 创建打印内容
    createPrintContent(data) {
      const printWindow = window.open('', '_blank');


      const reportType = this.activeSubTab === '日报统计' ? '日报统计' : '月报统计';
      const columns = this.getTableColumns();
      
      let html = `
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="UTF-8">

          <style>
            body { font-family: Arial, sans-serif; margin: 20px; }
            .header { text-align: center; margin-bottom: 30px; }
            .title { font-size: 24px; font-weight: bold; margin-bottom: 10px; }
            .info { font-size: 14px; color: #666; margin-bottom: 20px; }
            .search-info { background: #f5f5f5; padding: 10px; border-radius: 4px; margin-bottom: 20px; }
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            th, td { border: 1px solid #ddd; padding: 8px; text-align: center; font-size: 12px; }
            th { background-color: #f2f2f2; font-weight: bold; }
            .device-info { background-color: #f9f9f9; }
            @media print {
              body { margin: 0; }
              .no-print { display: none; }
            }
          </style>
        </head>
        <body>
          <div class="header">
            <div class="title">环境${reportType}报表</div>
            <div class="info">数据条数: ${data.length} 条</div>
          </div>
          

          <table>
            <thead>
              <tr>
                <th>编号</th>
                <th>表名</th>
                <th>安装位置</th>
                ${columns.map(col => `<th>${this.getColumnLabel(col)}</th>`).join('')}
              </tr>
            </thead>
            <tbody>
      `;
      
      data.forEach((item) => {
        html += `
          <tr>
            <td class="device-info">${item.id}</td>
            <td class="device-info">${item.name}</td>
            <td class="device-info">${item.location}</td>
            ${columns.map(col => `<td>${item.dailyData[col] || '-'}</td>`).join('')}
          </tr>
        `;
      });
      
      html += `
            </tbody>
          </table>
        </body>
        </html>
      `;
      
      printWindow.document.write(html);
      printWindow.document.close();
      printWindow.focus();
      
      // 等待内容加载完成后打印
      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 500);
    },

    // 获取搜索条件文本
    getSearchConditionsText() {
      const conditions = [];
      
      if (this.query.park) {
        conditions.push(`所属厂区: ${this.query.park}`);
      }
      if (this.query.building) {
        conditions.push(`所属楼号: ${this.query.building}`);
      }
      if (this.query.floor) {
        conditions.push(`所属楼层: ${this.query.floor}`);
      }
      if (this.query.installArea) {
        conditions.push(`安装位置: ${this.query.installArea}`);
      }
      if (this.query.facId) {
        const device = this.options.deviceList.find(d => d.fac_id === this.query.facId);
        conditions.push(`设备编号: ${this.query.facId}${device ? ` - ${device.fac_name}` : ''}`);
      }
      if (this.query.company) {
        conditions.push(`公司: ${this.query.company}`);
      }
      if (this.query.deviceType) {
        conditions.push(`设备类型: ${this.query.deviceType}`);
      }
      if (this.query.startDate) {
        conditions.push(`开始日期: ${this.query.startDate}`);
      }
      if (this.query.endDate) {
        conditions.push(`结束日期: ${this.query.endDate}`);
      }
      
      return conditions.length > 0 ? conditions.join(', ') : '无筛选条件';
    }
  }
};
</script>

<style scoped>
.tab-content {
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 24px;
}

.tab-content h1 {
  color: #333;
  font-size: 24px;
  margin-bottom: 24px;
  text-align: center;
}

/* 确保子tab样式正确应用 */
.subnav-bar {
  margin-bottom: 5px;
  margin-top: -40px;
}

.subnav-tab {
  padding: 6px 16px;
  font-size: 16px;
  margin-right: 8px;
}

/* 表格样式优化 */
.data-table th,
.data-table td {
  padding: 12px 8px;
  text-align: center;
  border-bottom: 1px solid #eee;
  font-size: 14px;
  min-width: 60px;
}

.data-table th:first-child,
.data-table td:first-child {
  min-width: 120px;
}

.data-table th:nth-child(2),
.data-table td:nth-child(2) {
  min-width: 200px;
}

.data-table th:nth-child(3),
.data-table td:nth-child(3) {
  min-width: 300px;
}

/* 分析标题样式 */
.analysis-title {
  text-align: center;
  margin: 24px 0;
  padding: 16px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 8px;
  color: white;
}

.analysis-title h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 500;
}

/* 图表容器样式 */
.charts-container {
  margin-top: 24px;
}

.chart-section {
  background: white;
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #eee;
}

.chart-header h3 {
  margin: 0;
  color: #333;
  font-size: 18px;
  font-weight: 500;
}

.chart-legend {
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 14px;
  color: #666;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #666;
}

.legend-color {
  width: 16px;
  height: 16px;
  border-radius: 3px;
}

.legend-color.blue {
  background-color: #2196F3;
}

.legend-color.pink {
  background-color: #E91E63;
}

.legend-color.green {
  background-color: #4CAF50;
}

.legend-color.orange {
  background-color: #FF9800;
}

.download-btn {
  background: #4CAF50;
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s;
}

.download-btn:hover {
  background: #45a049;
}

.chart-container {
  position: relative;
  height: 400px;
  width: 100%;
}

/* 无数据和加载状态样式 */
.no-data, .loading-state {
  text-align: center;
  padding: 48px;
  color: #999;
  font-size: 16px;
}

.loading-state {
  color: #666;
}



/* 统计摘要样式 */
.summary-section {
  margin-top: 24px;
}

.summary-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 24px;
}

.summary-card {
  background: white;
  border-radius: 8px;
  padding: 24px;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-left: 4px solid #2196F3;
}

.summary-title {
  color: #666;
  font-size: 14px;
  margin-bottom: 12px;
}

.summary-value {
  color: #333;
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 8px;
}

.summary-unit {
  color: #999;
  font-size: 12px;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .visibleDays {
    display: none;
  }
  
  .hasMoreDays {
    display: none;
  }
  
  .chart-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
  
  .chart-legend {
    flex-wrap: wrap;
  }
}

@media (max-width: 768px) {
  .chart-container {
    height: 300px;
  }
  
  .chart-section {
    padding: 16px;
  }
  
  .summary-cards {
    grid-template-columns: 1fr;
  }
}



/* 响应式设计 */
@media (max-width: 1200px) {
  .visibleDays {
    display: none;
  }
  
  .hasMoreDays {
    display: none;
  }
  
  .chart-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
  
  .chart-legend {
    flex-wrap: wrap;
  }
}

@media (max-width: 768px) {
  .chart-container {
    height: 300px;
  }
  
  .chart-section {
    padding: 16px;
  }
  
  .summary-cards {
    grid-template-columns: 1fr;
  }
}
</style>

